/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TemporaryLink { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    token: string;
    linkType: string;
    userId?: number;
    referenceId?: string;
    publicUrl?: string;
    expirationDate: string;
    used?: boolean;
    usedOn?: string;
    isActive?: boolean;
    codeHash?: string;
    codeExpiresAt?: string;
    codeAttempts?: number;
}

